<template>
  <form
    @submit="submit"
    class="align-self-stretch flex-grow-1 d-flex"
    :class="{'flex-column': $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'}"
  >
    <div
      class="body-2 mr-2 mt-3"
      v-if="$vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'"
    >{{index + 1}}.</div>

    <v-text-field
      outlined
      dense
      label="First Name*"
      class="mr-2 mb-1"
      v-model="firstName"
      :error-messages="$v.firstName.$dirty && $v.firstName.$error ? 'First Name is required.' : null"
    ></v-text-field>

    <v-text-field
      outlined
      dense
      label="Last Name*"
      class="mr-2 mb-1"
      v-model="lastName"
      :error-messages="$v.lastName.$dirty && $v.lastName.$error ? 'Last Name is required.' : null"
    ></v-text-field>

    <v-text-field
      outlined
      dense
      label="Player Email Address*"
      class="mr-2 mb-1"
      v-model="email"
      @input="onEmailInput"
      :error-messages="emailErrors"
    ></v-text-field>

    <v-text-field
      outlined
      dense
      label="Player Cell Phone"
      class="mr-2 mb-1"
      v-model="mobile"
      :error-messages="$v.mobile.$dirty && $v.mobile.$error ? 'Mobile must have 10 digits.' : null"
      @keypress="isNumber($event)"
    ></v-text-field>

    <v-text-field
      outlined
      dense
      label="Parent Email Address"
      class="mr-2 mb-1"
      v-model="parentEmail"
      :error-messages="parentEmailErrors"
    ></v-text-field>

    <v-select
      outlined
      dense
      label="Position*"
      class="mr-2 mb-1"
      :items="positions"
      item-text="name"
      item-value="id"
      v-model="position"
      :error-messages="$v.position.$dirty && $v.position.$error ? 'Position is required.' : null"
    ></v-select>

    <v-select
      outlined
      dense
      label="Graduation Year*"
      class="mr-2"
      :items="graduationYears"
      item-text="name"
      item-value="id"
      v-model="gradYear"
      :error-messages="$v.gradYear.$dirty && $v.gradYear.$error ? 'Position is required.' : null"
    ></v-select>

    <v-text-field
      outlined
      dense
      label="Jersey #"
      class="mr-2 mb-1"
      v-model="jerseyNum"
      maxlength="4"
      @keypress="isNumber($event)"
    ></v-text-field>
  </form>
</template>

<script>
import { db } from "@/db";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { debounce } from "throttle-debounce";
import firebase from "firebase/app";
import "firebase/auth";

const uniqueEmail = function () {
  return !this.emailExists;
};

const noDuplicateEmail = function () {
  return !this.isDuplicate;
};

export default {
  mixins: [validationMixin],
  props: ["positions", "graduationYears", "index", "duplicateEmails", "formId"],
  data() {
    return {
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      parentEmail: "",
      position: "",
      gradYear: "",
      jerseyNum: "",
      emailExists: false,
      isDuplicate: false,
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    email: { required, email, uniqueEmail, noDuplicateEmail },
    mobile: { minLength: minLength(10), maxLength: maxLength(10) },
    parentEmail: { email },
    position: { required },
    gradYear: { required },
  },
  created() {
    if (
      this.$vuetify.breakpoint.name == "xs" ||
      this.$vuetify.breakpoint.name == "sm"
    ) {
      this.$parent.$parent.$parent.$parent.$on("triggerSubmission", () => {
        this.submit();
      });
    } else {
      this.$parent.$on("triggerSubmission", () => {
        this.submit();
      });
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Email is required.");
      if (!this.$v.email.email)
        errors.push("Please enter a valid email format.");
      if (!this.$v.email.uniqueEmail) errors.push("This email already exists.");
      if (!this.$v.email.noDuplicateEmail)
        errors.push("Please remove duplicate emails");
      return errors;
    },
    parentEmailErrors() {
      const errors = [];
      if (!this.$v.parentEmail.$dirty) return errors;
      if (!this.$v.parentEmail.email)
        errors.push("Please enter a valid email format.");
      return errors;
    },
  },
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async submit() {
      this.$v.$touch();

      if (this.$v.email.required && this.$v.email.email) {
        const signInMethods = await firebase
          .auth()
          .fetchSignInMethodsForEmail(this.email);

        this.emailExists = signInMethods.length == 0 ? false : true;
      }

      this.$emit("setErrorState", {
        hasError: this.$v.$invalid,
        formId: this.formId,
      });

      if (this.$v.$invalid) return;

      this.$emit("athleteFormData", {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        mobile: this.mobile,
        parentEmail: this.parentEmail,
        position: this.position,
        gradYear: this.gradYear,
        jerseyNum: this.jerseyNum,
        formId: this.formId,
      });
    },
    onEmailInput: debounce(500, false, function () {
      if (
        this.$v.email.required &&
        this.$v.email.email &&
        this.$v.email.uniqueEmail &&
        !this.$v.email.noDuplicateEmail
      ) {
        this.$emit("recalcDuplicateEmails", {
          email: this.email,
          formId: this.formId,
        });
      }
    }),
  },
  watch: {
    duplicateEmails(newValue) {
      if (newValue.includes(this.formId)) {
        this.isDuplicate = true;
      } else {
        this.isDuplicate = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  .v-input {
    flex: 1;
  }
}
</style>